import MobileSliderPagesWrapper from "../components/MobileSliderPagesWrapper";
import React from "react";
import { connect } from "react-redux";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import NewLife from "../../../../modules/NewLife/NewLife.jsx";

function SlideMobileRespawn(props) {
    const {getLangPath} = useLangContext();

    return <MobileSliderPagesWrapper className={'p-0'}>

        {/*Module*/}
        <NewLife/>
    </MobileSliderPagesWrapper>
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(null, mapDispatchToProps)(SlideMobileRespawn);
